import React, { useEffect } from 'react';
import { navigate } from 'raviger';
import { toast } from 'react-toastify';
import { setUserSession } from '../../../backend/auth';
import { getBasePath } from '../../../App';
import PageLoader from '../../shared/PageLoader';

function SSOCallback() {
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        const error = urlParams.get('error');

        const isPopup = window.opener && !window.opener.closed;

        if (error) {
            const errorMessage = decodeURIComponent(error);

            if (isPopup) {
                window.opener.postMessage({
                    type: 'SSO_ERROR',
                    error: errorMessage
                }, window.location.origin);
                setTimeout(() => window.close(), 2000);
            } else {
                toast.error(errorMessage);
                navigate('/login');
            }
        } else if (token) {
            try {
                if (isPopup) {
                    window.opener.postMessage({
                        type: 'SSO_SUCCESS',
                        token: token
                    }, window.location.origin);
                    setTimeout(() => window.close(), 1000);
                } else {
                    setUserSession(token);
                    navigate('/');
                    window.location.reload();
                }
            } catch (error) {
                const errorMessage = 'Invalid SSO token received';
                if (isPopup) {
                    window.opener.postMessage({
                        type: 'SSO_ERROR',
                        error: errorMessage
                    }, window.location.origin);
                    setTimeout(() => window.close(), 2000);
                } else {
                    toast.error(errorMessage);
                    navigate('/login');
                }
            }
        } else {
            const errorMessage = 'No token received from SSO provider';
            if (isPopup) {
                window.opener.postMessage({
                    type: 'SSO_ERROR',
                    error: errorMessage
                }, window.location.origin);
                setTimeout(() => window.close(), 2000);
            } else {
                toast.error(errorMessage);
                navigate('/login');
            }
        }
    }, []);

    return (
        <PageLoader>
            <p>Processing SSO login...</p>
        </PageLoader>
    );
}

export default SSOCallback;
